import { DeleteIcon } from "@/components/common/icons/DeleteIcon/DeleteIcon"
import { LoadingSpinner } from "@/components/common/LoadingSpinner/LoadingSpinner"
import { Modal } from "@/components/common/Modal/Modal"
import { toast } from "@/components/common/Toast"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { useDeleteQuestionnaire } from "@/services/api/questionnaireService"
import { useEffect } from "react"
import { useNavigate } from "react-router"

interface DeleteQuestionnaireModalProps {
  questionnaireId: string
  setIsDeleteModalOpen: (isOpen: boolean) => void
}

export const DeleteQuestionnaireModal: React.FC<
  DeleteQuestionnaireModalProps
> = ({ questionnaireId, setIsDeleteModalOpen }) => {
  const { translate } = useTranslation()
  const navigate = useNavigate()

  const {
    mutate: deleteQuestionnaire,
    isPending: isDeleteQuestionnairePending,
    isSuccess: isDeleteQuestionnaireSuccess,
    isError: isDeleteQuestionnaireError,
  } = useDeleteQuestionnaire()

  useEffect(() => {
    if (isDeleteQuestionnaireError) {
      toast.error(translate("QUESTIONNAIRE/DELETE_MODAL/TOAST_DELETE_ERROR"))
    } else if (isDeleteQuestionnaireSuccess) {
      navigate("/")
      toast.success(
        translate("QUESTIONNAIRE/DELETE_MODAL/TOAST_DELETE_SUCCESS"),
      )
    }
  }, [
    isDeleteQuestionnaireSuccess,
    isDeleteQuestionnaireError,
    navigate,
    translate,
  ])

  const handleCloseDeleteModal = () => {
    setIsDeleteModalOpen(false)
  }

  return (
    <Modal
      showSidebarLeft
      ModalIcon={isDeleteQuestionnairePending ? LoadingSpinner : DeleteIcon}
      descriptionText={translate("QUESTIONNAIRE/DELETE_MODAL/DELETE_TEXT")}
      primaryActionTitle={translate("QUESTIONNAIRE/DELETE")}
      secondaryActionTitle={translate(
        "QUESTIONNAIRE/DELETE_MODAL/SAVE_QUESTIONNAIRE",
      )}
      onClose={handleCloseDeleteModal}
      onPrimaryAction={() => deleteQuestionnaire(questionnaireId)}
      onSecondaryAction={handleCloseDeleteModal}
    ></Modal>
  )
}
